<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="registration">
    <v-app-bar app flat height="79px">
      <a class="logo d-none d-sm-flex ma-sm-3">
        <v-img
          class="logo d-none d-sm-flex ma-sm-3"
          src="../assets/logo-plus.png"
          width="60px"
        ></v-img>
      </a>
      <v-spacer></v-spacer>
      <!-- переключатель языка -->
      <the-language-switcher />
    </v-app-bar>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            {{ $t("registration.complete_your_userinfo") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-alert
                v-if="registrationError"
                type="error"
                outlined
                class="mb-6"
              >
                {{ registrationError }}
              </v-alert>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="userName"
                    :label="$t('registration.username') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesUserNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-if="signingUser"
                    key="signing-user-code"
                    v-model="password"
                    :label="$t('registration.code') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesCodeField"
                    counter
                    maxlength="4"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    @keypress="onlyNumber"
                    @input="onCodeInput"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    key="user-password"
                    v-model="password"
                    :label="$t('user.password') + '*'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesCodeField"
                    counter
                    maxlength="50"
                    autocomplete="new-password"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                  <PasswordRequirements
                    v-if="administrativeRole"
                    :value="password"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :label="$t('registration.first_name') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesFirstNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="surname"
                    :label="$t('registration.last_name') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesLastNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              :loading="loading"
              :disabled="loading || !registrationToken"
              @click="saveUser"
            >
              {{ $t("registration.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            {{ $t("registration.your_userinfo") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.email_address")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.email }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.country_code")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationCountryCode }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.postal_code")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationPostalCode }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.place")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationPlace }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.street")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationStreet }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-footer id="nav" color="#fff">
      <v-container>
        <div class="d-flex align-center justify-space-between footer-box">
          <a class="logo">
            <v-img src="../assets/logo-plus.png" width="60px"></v-img>
          </a>

          <!-- <div class="d-flex align-center footer-menu">
                        <router-link :to="{name:'help'}">{{ $t('help') }}</router-link>
                        <router-link :to="{name:'faq'}">{{ $t('faq') }}</router-link>
                        <router-link :to="{name:'about'}">{{ $t('about') }}</router-link>
                    </div> -->

          <v-spacer></v-spacer>

          <div class="copyright-footer">
            &copy;
            {{ $t("copyright", { currentYear: this.$store.state.currentYear })
            }}<span>|</span>
            <router-link :to="{ name: 'help' }">{{
              $t("disclaimer")
            }}</router-link
            ><span>|</span>
            <router-link :to="{ name: 'help' }">{{
              $t("privacy_policy")
            }}</router-link>
          </div>
        </div>
      </v-container>
    </v-footer>
    <v-snackbar v-model="snackbar.show" bottom :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import config from "../config";
import Axios from "axios";
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher.vue";
import PasswordRequirements from "@/components/PasswordRequirements.vue";
import { isAdministrativeRole, isStrongPassword } from "@/utils/passwordPolicy";

export default {
  name: "Registration",
  components: {
    TheLanguageSwitcher,
    PasswordRequirements,
  },
  data() {
    return {
      registrationToken: "",
      loading: false,
      registrationError: "",
      errorMessagesUserNameField: "",
      errorMessagesCodeField: "",
      errorMessagesFirstNameField: "",
      errorMessagesLastNameField: "",
      showPassword: false,
      registrationRequestId: 0,
      user: {
        userName: "",
        password: "",
        name: "",
        surname: "",
        email: "",
        organization: "",
        operationCountryCode: "",
        operationPostalCode: "",
        operationPlace: "",
        operationStreet: "",
        role: "",
      },

      snackbar: {
        show: false,
        text: "",
        timeout: 4000,
      },
    };
  },
  mounted() {
    window.addEventListener("hashchange", this.handleVisibilityChange);
    window.addEventListener("pageshow", this.handlePageShow);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    document.addEventListener(
      "prerenderingchange",
      this.handleVisibilityChange
    );
    this.handleVisibilityChange();
  },
  beforeDestroy() {
    window.removeEventListener("hashchange", this.handleVisibilityChange);
    window.removeEventListener("pageshow", this.handlePageShow);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    document.removeEventListener(
      "prerenderingchange",
      this.handleVisibilityChange
    );
  },
  computed: {
    signingUser() {
      return (
        String(this.user.role || "")
          .trim()
          .toLowerCase() === "signing user"
      );
    },
    administrativeRole() {
      return isAdministrativeRole(this.user.role);
    },
    userName: {
      get() {
        return this.user.userName;
      },
      set(v) {
        this.user.userName = v;
      },
    },
    password: {
      get() {
        return this.user.password;
      },
      set(v) {
        this.user.password = v;
      },
    },
    name: {
      get() {
        return this.user.name;
      },
      set(v) {
        this.user.name = v;
      },
    },
    surname: {
      get() {
        return this.user.surname;
      },
      set(v) {
        this.user.surname = v;
      },
    },
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState !== "visible" || document.prerendering) {
        return;
      }

      this.initializeRegistration();
    },

    handlePageShow(event) {
      if (event.persisted || window.location.hash) {
        this.initializeRegistration();
      }
    },

    initializeRegistration() {
      const fragmentParams = new URLSearchParams(
        window.location.hash.substring(1)
      );
      const token = fragmentParams.get("token") || "";

      // replaceState below removes the fragment. A pageshow event without a
      // new token must not invalidate registration that is already loaded.
      if (!token) {
        if (!this.registrationToken) {
          this.registrationError = this.invalidRegistrationLinkMessage();
        }
        return;
      }

      if (token === this.registrationToken) return;

      this.registrationToken = token;
      this.registrationError = "";
      this.showPassword = false;
      this.user = {
        userName: "",
        password: "",
        name: "",
        surname: "",
        email: "",
        organization: "",
        operationCountryCode: "",
        operationPostalCode: "",
        operationPlace: "",
        operationStreet: "",
        role: "",
      };

      window.history.replaceState(
        null,
        document.title,
        window.location.pathname + window.location.search
      );

      this.loadRegistrationData(token);
    },

    invalidRegistrationLinkMessage() {
      return (
        "This registration link is invalid, expired, or has already been used. " +
        "Please contact your administrator to request a new invitation."
      );
    },

    getApiError(error, fallbackMessage) {
      const responseData = error && error.response && error.response.data;
      const apiMessage =
        typeof responseData === "string"
          ? responseData
          : responseData && responseData.message;

      if (apiMessage && /invalid|expired|already been used/i.test(apiMessage)) {
        return this.invalidRegistrationLinkMessage();
      }

      return apiMessage || fallbackMessage;
    },

    loadRegistrationData(token = this.registrationToken) {
      const requestId = ++this.registrationRequestId;
      this.loading = true;
      this.registrationError = "";

      Axios.post(
        config.apiBaseUrl +
          "api/employee/signing-user?_=" +
          encodeURIComponent(Date.now()),
        { token },
        { headers: { "Content-Type": "application/json" } }
      )
        .then((response) => {
          if (
            requestId !== this.registrationRequestId ||
            token !== this.registrationToken
          ) {
            return;
          }

          const data = response.data || {};

          this.user = {
            userName: data.userName || "",
            password: "",
            name: data.name || "",
            surname: data.surname || "",
            email: data.email || "",
            organization: data.organization || "",
            operationCountryCode: data.operationCountryCode || "",
            operationPostalCode: data.operationPostalCode || "",
            operationPlace: data.operationPlace || "",
            operationStreet: data.operationStreet || "",
            role: data.roleName || "",
          };
        })
        .catch((error) => {
          if (
            requestId !== this.registrationRequestId ||
            token !== this.registrationToken
          ) {
            return;
          }

          this.registrationError = this.getApiError(
            error,
            this.invalidRegistrationLinkMessage()
          );
        })
        .finally(() => {
          if (requestId === this.registrationRequestId) {
            this.loading = false;
          }
        });
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode === 46 || keyCode === 192) {
        // 46 is dot
        this.errorMessagesCodeField = this.$i18n.t("enterOnlyNumbers");
        $event.preventDefault();
      }
    },

    onCodeInput(v) {
      const cleaned = String(v || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      if (cleaned !== this.user.password) {
        this.user.password = cleaned;
      }
    },

    saveUser(e) {
      e.preventDefault();

      if (this.loading) return;

      if (!this.registrationToken) {
        this.registrationError = this.invalidRegistrationLinkMessage();
        return;
      }

      this.registrationError = "";
      this.errorMessagesUserNameField = "";
      this.errorMessagesCodeField = "";
      this.errorMessagesFirstNameField = "";
      this.errorMessagesLastNameField = "";

      let errorsCount = 0;

      const user = this.user || {};

      if (!user.userName || user.userName.trim().length === 0) {
        this.errorMessagesUserNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (this.signingUser && !/^\d{4}$/.test(String(user.password || ""))) {
        this.errorMessagesCodeField = this.$i18n.t("error_check_code_length");
        errorsCount++;
      } else if (!this.signingUser && !String(user.password || "")) {
        this.errorMessagesCodeField = this.$i18n.t("field_is_required");
        errorsCount++;
      } else if (this.administrativeRole && !isStrongPassword(user.password)) {
        this.errorMessagesCodeField =
          "The password does not meet the required complexity.";
        errorsCount++;
      }

      if (!user.name || user.name.trim().length === 0) {
        this.errorMessagesFirstNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (!user.surname || user.surname.trim().length === 0) {
        this.errorMessagesLastNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (errorsCount !== 0) return;

      const request = {
        token: this.registrationToken,
        userName: user.userName,
        password: user.password,
        name: user.name,
        surname: user.surname,
      };

      this.loading = true;

      Axios.post(
        config.apiBaseUrl + "api/employee/edit-signing-user",
        request,
        { headers: { "Content-Type": "application/json" } }
      )
        .then(() => {
          this.registrationToken = "";
          this.user.password = "";

          // Registration is a public flow. Remove a possibly existing
          // application session so the login route is shown after completion.
          [
            "userName",
            "accessToken",
            "role",
            "userId",
            "guid",
            "organization",
            "organizationId",
            "permissions",
            "showNewDashboardSign",
            "spotCharterUsingSign",
            "loginMS",
          ].forEach((key) => localStorage.removeItem(key));

          this.$router.replace({
            name: "login",
            query: { registrationCompleted: "true" },
          });
        })
        .catch((error) => {
          this.registrationError = this.getApiError(
            error,
            "Registration could not be completed."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    userName() {
      this.errorMessagesUserNameField = "";
    },
    password() {
      this.errorMessagesCodeField = "";
    },
    name() {
      this.errorMessagesFirstNameField = "";
    },
    surname() {
      this.errorMessagesLastNameField = "";
    },
  },
};
</script>
